import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import WarehouseStockStatus from "./warehousestockstatus.js";
import WarehouseIndents from "./warehouseindent.js";
import WarehouseLane from "./warehouselane.js";
import OpenPo from "./openpo.js";
import WHDDData from "./warehouse_demand_distribution_data.js"


const TABS = [
  { key: "warehouse_lane", label: "Warehouse Lane" },
   { key: "open_po", label: "Open PO" },
  { key: "stock_status", label: "Stock Status" },
  // { key: "demand_distribution", label: "Demand Distribution" },
  { key: "raise_indents", label: "Raise Indents" },
 
];

const WarehouseIndentation = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "stock_status";

  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    // Whenever tab changes, update the URL query
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case "stock_status":
        return <WarehouseStockStatus />;
      case "raise_indents":
        return <WarehouseIndents />;
      case "warehouse_lane":
        return <WarehouseLane />;
      case "open_po":
        return <OpenPo />;
        case "demand_distribution":
          return <WHDDData/>
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid mt-3">
      {/* ---------- Header ---------- */}
      <div className="row" style={{ fontFamily: "Arial, sans-serif", fontSize: "0.9rem" }}>
        <div className="col-sm-12 p-0">
          <h1
            style={{
              color: "#B9366D",
              fontSize: "18px",
              fontWeight: "bold",
              fontFamily: "sans-serif",
            }}
          >
            Warehouse Indentation
          </h1>
        </div>

        {/* ---------- Tabs ---------- */}
        <div className="col-sm-12 p-0 mt-3">
          <ul className="nav nav-tabs" role="tablist" style={{ borderBottom: "1px solid #dee2e6" }}>
            {TABS.map((tab) => (
              <li key={tab.key} className="nav-item" role="presentation">
                <button
                  type="button"
                  className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                  onClick={() => handleTabClick(tab.key)}
                  style={{
                    fontSize: "14px",
                    fontWeight: activeTab === tab.key ? 600 : 500,
                    color: activeTab === tab.key ? "#93385D" : "#555",
                    backgroundColor: activeTab === tab.key ? "#fff" : "#f8f9fa",
                    border: "none",
                    borderBottom: `2px solid ${
                      activeTab === tab.key ? "#93385D" : "transparent"
                    }`,
                    padding: "8px 20px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* ---------- Tab Content ---------- */}
        <div className="col-sm-12 p-0 mt-2 tab-content row ">{renderActiveTab()}</div>
      </div>

      {/* ---------- Loader & Overlay ---------- */}
      {/* <div className={`loader ${loadshow}`} />
      <div className={`overlay-block ${overlayBlock}`} /> */}
    </div>
  );
};

export default WarehouseIndentation;
